import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State, can_save_to_onshape } from '../../state';
import BarButton from '@components/bar-button';
import onshape_svg from '../../../assets/img/SVG_icons/Right/import-export/send_to_onshape.svg';
import { img } from '@phi/components';
import { IAuthentication } from '@phi/authentication/frontend';
import { show_export_to_onshape_modal } from '@frontend/input_output';
import SendToOnshapeTooltip from './SendToOnshapeTooltip';

export const SendToOnshapeIcon = onshape_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },

        auth: { required: true, type: Object as PropType<IAuthentication> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Export to Onshape';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || !can_save_to_onshape();
        },
    },

    methods: {
        onClick() {
            if (this.state.is_demo)
                this.auth.show_must_login_modal();
            else if (this.disabled)
                return;
            else
                show_export_to_onshape_modal();
        },
    },

    render() {
        return h(BarButton, {
            id: 'send-to-onshape-button',
            tippy: 'right',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 12,
            help: 'send_to_onshape',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(onshape_svg, this.alt),
            tooltip: SendToOnshapeTooltip,
        });
    },
});
